import { DataGrid, GridColDef } from "@mui/x-data-grid";
import NameAndImageCell from "../../components/Tables/NameAndImageCell";
import SettingsMenu from "../../components/SettingsMenu/SettingsMenu";
import TitleArea from "../../components/Layout/TitleArea/TitleArea";
import SearchBar from "../../components/SearchBar/SearchBar";
import { useNavigate } from "react-router";
import { CHILD_DETAILS } from "../../common/constants/routes.constants";
import { useEffect, useState } from "react";
import { ITableChildren } from "../../common/interfaces/children.interface";
import { getAllChildren } from "../../api/children.api";
import InitialsArray from "../../components/Tables/InitialsArray";
import { formatDateString, toggleSort } from "../../common/utils/helpers";
import Loader from "../../components/Loader/Loader";
import { ITEMS_PER_PAGE } from "../../common/constants/common.constants";

const columns: GridColDef[] = [
  {
    field: "name",
    headerName: "CHILD",
    headerClassName: "table-header",
    flex: 15,
    renderCell: (params) => {
      return (
        <NameAndImageCell
          personId={params.row.id}
          fullName={params.row.name + " " + params.row.surname}
          imgUrl={params.row.childAvatarURL}
        />
      );
    },
  },
  {
    field: "birthDate",
    headerName: "DATE OF BIRTH",
    headerClassName: "table-header",
    flex: 10,
    sortable: false,
    renderCell: (params) => {
      return <span>{formatDateString(params.row.birthDate)}</span>;
    },
  },
  {
    field: "group",
    headerName: "GROUP",
    headerClassName: "table-header",
    flex: 10,
    sortable: false,
    renderCell: (params) => {
      return <span>{params.row.group.groupName}</span>;
    },
  },
  {
    field: "parents",
    headerName: "PARENTS",
    headerClassName: "table-header",
    flex: 10,
    sortable: false,
    renderCell: (params) => {
      return (
        <div className="tablecell-image-array">
          <InitialsArray
            fullnames={params.row.parents.map(
              (parent: any) => parent.parentFullName
            )}
          />
        </div>
      );
    },
  },
  {
    field: "address",
    headerName: "ADDRESS",
    headerClassName: "table-header",
    flex: 15,
    sortable: false,
  },
];

const ChildrenPage = () => {
  const [children, setChildren] = useState<ITableChildren[]>();
  const [page, setPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("");
  const [filter, setFilter] = useState("");
  const [queryParam, setQueryParam] = useState("");
  const [totalCount, setTotalCount] = useState<number>();

  const navigate = useNavigate();

  useEffect(() => {
    if (queryParam) fetchData();
  }, [queryParam]);

  useEffect(() => {
    setQueryParam(
      `?page=${page}&paginationItemsPerPage=${ITEMS_PER_PAGE}&filter=${filter}&sortBy=name&sortOrder=${sortOrder}`
    );
  }, [page, sortOrder, filter]);

  const fetchData = async () => {
    try {
      const response = await getAllChildren(queryParam);
      setChildren(response.data);
      setTotalCount(response.totalCount);
    } catch (error: any) {
      console.log(error.message);
    }
  };

  const handleRowClick = (params: any) => {
    navigate(`${CHILD_DETAILS}/${params.id}`);
  };

  const handlePageChange = (e: any) => {
    setPage(e.page + 1);
  };

  const handleSortChange = () => {
    setSortOrder(toggleSort(sortOrder));
  };

  return (
    <div className="padding-wrapper">
      <SettingsMenu />
      <TitleArea />
      {children ? (
        <>
          <SearchBar setSearchValue={(value) => setFilter(value)} />
          <DataGrid
            onRowClick={(params) => handleRowClick(params)}
            getRowId={(row) => row.childId}
            rows={children}
            disableColumnMenu
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            rowCount={totalCount}
            sx={{ border: 0 }}
            onPaginationModelChange={(e: any) => handlePageChange(e)}
            onSortModelChange={handleSortChange}
            sortingMode="server"
            paginationMode="server"
            sortingOrder={["asc", "desc"]}
            disableColumnSelector={true}
            localeText={{ noRowsLabel: "No data available" }}
          />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default ChildrenPage;
